__webpack_require__.p = "/gen-ai-course-in-coimbatore/";